export default "__VITE_ASSET__BzqXGUPC__"